import React from 'react';

/**
 * @typedef {object} RegionData
 * @property {string} label
 * @property {boolean} isLabelHidden
 */

/** @type {Record<string, RegionData>} */
const regionMap = Object.freeze({
  APAC: {
    label: 'Asia Pacific',
    isLabelHidden: true,
  },
  EMEA: {
    label: 'Europe, the Middle East and Africa',
    isLabelHidden: true,
  },
  NAM: {
    label: 'North America',
    isLabelHidden: true,
  },
  GLOBAL: {
    label: 'Global',
    isLabelHidden: false,
  },
});

/** @param {{children: string}} props.children */
const Region = ({ children }) => {
  const region = regionMap[children];
  if (!region) {
    return children;
  } else if (region.isLabelHidden) {
    return (
      <abbr aria-label={region.label} title={region.label}>
        {children}
      </abbr>
    );
  } else {
    return region.label;
  }
};

export default Region;
